@if (langChanges$ | async; as lang) {
  <p class="lang-container">
    <span (click)="handleLangChange('en')" [ngClass]="{ active: lang === 'en' }">EN</span>
    <span class="line"></span>
    <span (click)="handleLangChange('nl')" [ngClass]="{ active: lang === 'nl' }">NL</span>
  </p>
}
